import QRCode from 'react-qr-code';
import { QRProps } from '../interface/interface';

const CustomQR = ({ value, size, className }: QRProps) => {
  return <QRCode value={value} size={size} className={className} />;
};

export default CustomQR;
